/* Hairecover scalp quiz + quiz pop-up.
   Privacy: answers live only in localStorage ('hcQuiz'). Nothing here sends answers or email
   to analytics, pixels or dataLayer. Recommendation rules: function recommend(). */
(() => {
  'use strict';
  const KEY = 'hcQuiz';
  const POP_KEY = 'hcQuizPopSeen';
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------------- Recommendation ---------------- */
  const WAND = 'high-frequency-scalp-wand', BRUSH = 'mistevyn-4-in-1-led-mist-brush', POD = '7-light-scalp-massager',
    COMB = 'red-light-travel-comb', MIST = 'mistevyn-4-in-1-led-mist-brush', OIL = 'olestrya-daily-scalp-oil',
    SERUM = 'folivryn-precision-roll-on-scalp-serum', TONIC = 'rosemary-root-tonic', SILI = 'silicone-scalp-massager';

  function topicalFor(a) {
    if (a.goal === 'scalp' || a.goal === 'ritual') return OIL;
    if (a.focus === 'hairline' || a.focus === 'part') return SERUM;
    return TONIC;
  }

  function recommend(a) {
    let main, add;
    const t = topicalFor(a);
    if (a.budget === 'low') {
      if (a.pref === 'device') { main = SILI; add = t === OIL ? TONIC : t; }
      else { main = t; add = SILI; }
    } else if (a.where === 'travel') {
      main = COMB; add = (a.goal === 'scalp' || a.goal === 'ritual') ? OIL : SERUM;
    } else if (a.feel === 'tingle' && a.pref !== 'topical') {
      main = a.budget === 'high' ? WAND : POD; add = t;
    } else if (a.pref === 'topical') {
      main = t; add = a.budget === 'high' ? POD : SILI;
    } else if (a.pref === 'both') {
      if (a.feel === 'light') { main = MIST; add = t === TONIC ? SERUM : t; }
      else if (a.feel === 'massage') { main = POD; add = t; }
      else { main = BRUSH; add = t === TONIC ? SERUM : t; }
    } else { // device
      main = a.feel === 'massage' ? POD : BRUSH; add = t;
    }
    if (main === BRUSH && add === TONIC) add = SERUM; // brush kits already pair with the tonic
    if ([POD, COMB, WAND, BRUSH].includes(main) && add === OIL) add = SERUM; // devices already ship with a free Olestrya oil (1 per order)
    if (add === main) add = SILI;
    return { main, add };
  }

  function variantFor(p, handle, a, isMain) {
    const avail = p.variants.filter(v => v.available);
    const list = avail.length ? avail : p.variants;
    if (isMain && handle === BRUSH) {
      const want = a.budget === 'high' ? /complete/i : /starter/i;
      return list.find(v => want.test(v.title)) || list[0];
    }
    return list[0];
  }

  const LABELS = {
    goal: { volume: 'more volume', fuller: 'fuller-looking hair', scalp: 'a healthier-looking scalp', ritual: 'a relaxing ritual' },
    focus: { hairline: 'the hairline', part: 'your part line', crown: 'the crown', all: 'your whole scalp' },
    time: { 5: 'about 5 minutes', 10: 'about 10 minutes', 15: '15+ minutes' },
    feel: { light: 'gentle light', massage: 'massage', tingle: 'a warm tingle' }
  };
  const TITLES = { volume: 'Volume-Look Routine', fuller: 'Fuller-Look Routine', scalp: 'Fresh Scalp Routine', ritual: 'Relaxing Scalp Ritual' };
  const ROLE = {
    [WAND]: 'Warm, tingling high-frequency glow for your scalp massage.',
    [BRUSH]: 'Light, gentle vibration and a precise applicator in one brush.',
    [POD]: 'Seven soft lights with a soothing vibrating massage.',
    [COMB]: 'Compact red-light massage comb that travels with you.',
    [MIST]: 'LED light, fine mist and massage in a single step.',
    [OIL]: 'Nourishing leave-in oil for a calm, conditioned-feeling scalp.',
    [SERUM]: 'Roll-on serum that goes exactly where you want it.',
    [TONIC]: 'Light rosemary mist that refreshes the whole scalp.',
    [SILI]: 'Soft silicone massager for a relaxing shampoo moment.'
  };

  /* ---------------- Quiz page ---------------- */
  function initQuiz(root) {
    const dataEl = document.getElementById('hcq-products');
    let products = {};
    try { products = JSON.parse(dataEl.textContent); } catch (e) {}
    const steps = [...root.querySelectorAll('.hcq-step')];
    const order = steps.map(s => s.dataset.step);
    const bar = root.querySelector('[data-hcq-bar]');
    const prog = root.querySelector('.hcq-progress');
    const back = root.querySelector('[data-hcq-back]');
    const stages = root.querySelectorAll('[data-hcq-stage]');
    const saved = store.get(KEY) || {};
    let answers = saved.answers || {};
    const history = [];
    let current = null;

    function save(extra) { store.set(KEY, Object.assign({ answers, ts: Date.now() }, extra || {})); }

    function show(name, push = true) {
      if (current && push) history.push(current);
      current = name;
      steps.forEach(s => { s.hidden = s.dataset.step !== name; });
      const step = steps.find(s => s.dataset.step === name);
      const pct = +step.dataset.progress || 0;
      bar.style.width = pct + '%';
      prog.setAttribute('aria-valuenow', pct);
      stages.forEach(li => {
        const n = +li.dataset.hcqStage, cur = +step.dataset.stage;
        li.classList.toggle('is-on', n === cur); li.classList.toggle('is-done', n < cur);
      });
      back.hidden = !history.length || name === 'loading' || name === 'result';
      step.querySelectorAll('[data-q]').forEach(b => b.setAttribute('aria-pressed', answers[b.dataset.q] === b.dataset.v ? 'true' : 'false'));
      const h = step.querySelector('.hcq-h');
      if (h && push) h.focus({ preventScroll: true });
      if (push) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      if (name === 'loading') setTimeout(() => show('email'), 1800);
      if (name === 'result') renderResult();
    }

    function next() {
      const i = order.indexOf(current);
      show(order[i + 1]);
    }

    root.addEventListener('click', e => {
      const opt = e.target.closest('[data-q]');
      if (opt) {
        answers[opt.dataset.q] = opt.dataset.v;
        save();
        opt.setAttribute('aria-pressed', 'true');
        setTimeout(next, 180);
        return;
      }
      if (e.target.closest('[data-hcq-next]')) next();
      if (e.target.closest('[data-hcq-skip]')) show('result');
      if (e.target.closest('[data-hcq-back]') && history.length) { current = null; show(history.pop(), false); current = current; }
      if (e.target.closest('[data-hcq-restart]')) { answers = {}; save({ done: false }); history.length = 0; current = null; show('goal'); }
      const addBtn = e.target.closest('[data-hcq-add]');
      if (addBtn) addToCart(addBtn);
    });

    function money(p, v) { return v ? v.price : ''; }

    function card(handle, isMain) {
      const p = products[handle];
      if (!p) return '';
      const v = variantFor(p, handle, answers, isMain);
      const title = p.title.replace(/^(Arqevyn|Mistevyn|Olestrya|Folivryn):\s*/, '');
      return `<article class="hcq-pick${isMain ? ' hcq-pick--main' : ''}">
        <a class="hcq-pick-img" href="${p.url}"><img src="${p.img}" alt="${esc(p.alt)}" width="600" height="600" loading="lazy"></a>
        <div class="hcq-pick-body">
          <p class="hcq-eyebrow">${isMain ? 'Your main step' : 'Pairs well with'}</p>
          <h3><a href="${p.url}">${esc(title)}</a></h3>
          <p>${ROLE[handle] || ''}</p>
          <p class="hcq-price">${money(p, v)}${p.variants.length > 1 ? ` <small>${esc(v.title)}</small>` : ''}</p>
          <button type="button" class="hcq-cta hcq-cta--sm" data-hcq-add="${v.id}" ${v.available ? '' : 'disabled'}>${v.available ? 'Get yours' : 'Sold out'}</button>
        </div></article>`;
    }

    function esc(s) { return String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }

    function renderResult() {
      const r = recommend(answers);
      save({ done: true });
      root.querySelector('[data-hcq-rtitle]').textContent = 'Your ' + (TITLES[answers.goal] || 'Scalp Routine');
      const bits = [];
      if (answers.goal) bits.push(LABELS.goal[answers.goal]);
      if (answers.focus) bits.push('focused on ' + LABELS.focus[answers.focus]);
      if (answers.time) bits.push(LABELS.time[answers.time] + ' a day');
      if (answers.feel) bits.push(LABELS.feel[answers.feel]);
      root.querySelector('[data-hcq-why]').textContent = bits.length ? 'Picked for ' + bits.join(', ') + '.' : 'Your 10-minute routine, ready to start tonight.';
      const main = products[r.main] ? r.main : Object.keys(products)[0];
      const add = products[r.add] && r.add !== main ? r.add : null;
      const eb = root.querySelector('[data-hcq-eyebrow]');
      if (eb) eb.textContent = [POD, COMB, WAND, BRUSH].includes(main) ? 'Your routine is ready — claim your free gifts' : 'Your routine is ready';
      let html = card(main, true) + (add ? card(add, false) : '');
      const ids = [main, add].filter(Boolean).map(h => variantFor(products[h], h, answers, h === main)).filter(v => v && v.available).map(v => v.id);
      if (ids.length > 1) html += `<button type="button" class="hcq-cta hcq-cta--wide" data-hcq-add="${ids.join(',')}">Get the full routine</button>`;
      root.querySelector('[data-hcq-picks]').innerHTML = html;
      const media = root.querySelector('[data-hcq-media]');
      const vp = [main, add].map(h => h && products[h]).find(p => p && p.video);
      if (vp) {
        const vid = root.querySelector('[data-hcq-video]');
        vid.dataset.src = vp.video; if (vp.poster) vid.poster = vp.poster;
        media.hidden = false;
        if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          new IntersectionObserver(es => es.forEach(en => {
            if (en.isIntersecting) { if (!vid.getAttribute('src')) vid.src = vid.dataset.src; vid.muted = true; vid.play().catch(() => {}); }
            else vid.pause();
          }), { threshold: 0.5 }).observe(vid);
        } else { vid.src = vid.dataset.src; vid.controls = true; }
      } else media.hidden = true;
    }

    async function addToCart(btn) {
      const ids = btn.dataset.hcqAdd.split(',').map(Number);
      const label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      try {
        /* Aparelho entra com os brindes, igual à PDP (mesmos rótulos _gift do tema) */
        const GIFTS = { 52950818947301: [[67587296493797, 52950532128997], 'Pod'], 52950803808485: [[67575993368805], 'Laser cap'], 67575993204965: [[67575993368805], 'Mistevyn'], 52950273589477: [[67575993368805], 'Arqevyn'], 66778260275429: [[67575993368805], 'Rovilynx'] };
        const cart = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js').then(r => r.json()).catch(() => ({ items: [] }));
        const have = new Set((cart.items || []).filter(i => i.properties && i.properties._gift).map(i => i.variant_id));
        const items = ids.map(id => ({ id, quantity: 1 }));
        ids.forEach(id => { const g = GIFTS[id]; if (g) g[0].forEach(v => { if (!have.has(v)) { have.add(v); items.push({ id: v, quantity: 1, properties: { _gift: g[1] } }); } }); });
        await window.hcAddToCart(items);
        btn.disabled = false; btn.textContent = label;
      } catch (e) {
        btn.disabled = false; btn.textContent = label;
        let msg = btn.parentNode.querySelector('.hcq-add-error');
        if (!msg) { msg = document.createElement('p'); msg.className = 'hcq-add-error'; msg.setAttribute('role', 'alert'); msg.style.cssText = 'color:#b42318;font-size:14px;margin:8px 0 0'; btn.insertAdjacentElement('afterend', msg); }
        msg.textContent = (e && e.message) || 'Sorry, we could not add this to your cart. Please try again.';
      }
    }

    // Entry point
    const params = new URLSearchParams(location.search);
    const posted = params.get('customer_posted') === 'true' || params.get('hcq') === 'done' || root.querySelector('[data-hcq-posted]');
    const hasError = root.querySelector('.hcq-error');
    const goal = params.get('goal');
    if (hasError) { show('email', false); }
    else if (posted && answers.goal) { root.querySelector('[data-hcq-code]').hidden = false; show('result', false); }
    else if (goal && LABELS.goal[goal]) { answers = { goal }; save(); history.push('goal'); show('focus', false); }
    else show('goal', false);
  }

  /* ---------------- Pop-up ---------------- */
  function initPopup(pop) {
    const path = location.pathname;
    if (/\/(cart|checkout|checkouts)(\/|$)|\/pages\/scalp-quiz/.test(path)) return;
    const seen = store.get(POP_KEY);
    if (seen && Date.now() - seen < 7 * 864e5) return;
    const dialog = pop.querySelector('[role="dialog"]');
    let opened = false, lastFocus = null;
    const promoOpen = () => !!document.querySelector('.sign-up-popup-modal.popup-modal--active, .success-popup-modal.popup-modal--active');
    // If the WELCOME10 promo pop-up already showed this visit, stay quiet.
    const promo = document.querySelector('.sign-up-popup-modal');
    if (promo && 'MutationObserver' in window) {
      new MutationObserver(() => {
        if (promo.classList.contains('popup-modal--active')) {
          try { sessionStorage.setItem('hcPromoShown', '1'); } catch (e) {}
          if (opened) { // never two at once: close the promo while the quiz pop-up is open
            promo.classList.remove('popup-modal--active');
            const ov = document.querySelector('.sign-up-popup-overlay'); if (ov) ov.classList.remove('popup-overlay--active');
          }
        }
      }).observe(promo, { attributes: true, attributeFilter: ['class'] });
    }
    const promoShown = () => { try { return sessionStorage.getItem('hcPromoShown') === '1'; } catch (e) { return false; } };

    function open() {
      if (opened || promoOpen() || promoShown() || document.querySelector('cart-drawer.active')) return;
      opened = true;
      store.set(POP_KEY, Date.now());
      lastFocus = document.activeElement;
      pop.hidden = false;
      document.documentElement.classList.add('hcqp-lock');
      requestAnimationFrame(() => pop.classList.add('is-open'));
      dialog.focus();
      cleanup();
    }
    function close() {
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('hcqp-lock');
      setTimeout(() => { pop.hidden = true; }, 200);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    pop.addEventListener('click', e => {
      if (e.target.closest('[data-hcqp-close]') || e.target === pop) close();
    });
    pop.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') {
        const f = [...dialog.querySelectorAll('a[href],button:not([disabled])')].filter(el => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    const timer = setTimeout(open, 20000);
    function onScroll() {
      const h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0 && scrollY / h >= 0.5) open();
    }
    function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0) open(); }
    const desktop = matchMedia('(hover: hover) and (pointer: fine)').matches;
    addEventListener('scroll', onScroll, { passive: true });
    if (desktop) document.addEventListener('mouseout', onLeave);
    function cleanup() {
      clearTimeout(timer);
      removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onLeave);
    }
    window.hcQuizPopup = { open, close }; // for QA
  }

  function boot() {
    const q = document.querySelector('[data-hcq]'); if (q) initQuiz(q);
    const p = document.querySelector('[data-hcqp]'); if (p) initPopup(p);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
